// Opening the ⌘K palette from anywhere. A window event rather than shared
// state: the palette is mounted once in App, and the callers (the header's
// Search chip, a name inside the About drawer's prose) have no relationship to
// it beyond "show me this". Its own module so component files stay
// component-only for fast refresh.

export const OPEN_PALETTE_EVENT = 'open-command-palette';

export interface OpenPaletteDetail {
  /** Prefill the search box — a composer's name, a title. */
  query?: string;
}

/**
 * Open the palette, optionally on a search. With no query this TOGGLES, which
 * is what a search button in the header should do; with one it always opens,
 * because a link that closes the thing you asked to see is a bug.
 */
export function openPalette(query?: string): void {
  window.dispatchEvent(new CustomEvent<OpenPaletteDetail>(OPEN_PALETTE_EVENT, { detail: { query } }));
}
